<template>
    <div class="journey view" id="journey">
        <div class="journey-top">
            <div class="vehicle" v-if="vehicle">
                <div class="icon-slot">
                    <icon class="video-icon" icon="video" :height="20" :width="20" />
                </div>
                <div class="reg-number">
                    Reg Number: <span>{{ vehicle.driverName || 'Any' }} / {{ vehicle.vrn || vehicle.registrationNumber || 'Unknown' }}</span>
                </div>
                <div class="make">
                    Make: <span>{{ vehicle.manufacturer }}</span>
                </div>
                <div class="make">
                    Model: <span>{{ vehicle.model }}</span>
                </div>
                <div class="make">
                    Engine size: <span>{{ vehicle.engineSize }}</span>
                </div>
                <div class="make">
                    Year: <span>{{ vehicle.yearOfManufacture }}</span>
                </div>
            </div>
            <div class="events">
                <ul>
                    <li @click="isSpeedGraphShow = !isSpeedGraphShow">Driving speed</li>

                        <v-tooltip v-for="event in events" :key="event.id" top>
                            <template v-slot:activator="{ on }">
                                    <li :class="['icon', event.name.toLowerCase(), event.counter === 0? 'disabled': '',  activeEventTypes.includes(event.id) && event.counter !== 0? 'active': '' ]" @click="eventAvailable(event.id)" v-on="on">{{ event.counter }}</li>
                            </template>
                            <span>{{ event.name }}</span>
                        </v-tooltip>
                </ul>
            </div>
        </div>
        <div class="overview">
            <div class="left-side">
                <div class="journey-status" :class="journeyStatus">
                    Journey Overview
                </div>
                <div class="journey-list">
                    <v-menu
                        ref="isDatePickerShow"
                        v-model="isDatePickerShow"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="dateString"
                                label="Picker in menu"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                                outline
                                single-line
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="dateString" @input="dateChanged" no-title scrollable :max="maxJourneyDatePickerDate">
                        </v-date-picker>
                    </v-menu>
                </div>
            </div>
            <div class="right-side">
                <div class="buttons">
                    <div class="button-box">
                        <sp-button @click.native="isJourneyTableShow = !isJourneyTableShow" sp-class="no-padding-right" icon="bar" text="Journey List"></sp-button>
                    </div>
                    <div v-if="hasAllRoles(['EventShareView'])" class="button-box">
                        <sp-button @click.native="isSnapshotsTableShow = !isSnapshotsTableShow" sp-class="no-padding-right" small-icon icon="arrow-left" text="Show Events / Snapshots"></sp-button>
                    </div>
                    <div class="button-box" v-if="isStreamingHardware">
                        <sp-button @click.native="isRemotePlaybackModal = !isRemotePlaybackModal" :disabled="!isHardwareOnline || activeDevice == null" sp-class="no-padding-right" icon="playback" :text="remotePlaybackPreviewButtonText"></sp-button>
                    </div>
                    <div class="button-box" v-if="isStreamingHardware">
                        <sp-button @click.native="isLivePreviewModal = !isLivePreviewModal" :disabled="!isHardwareOnline || isLiveStreaming" sp-class="no-padding-right" icon="playback" :loading="livePreviewStatus === 'processing'" :text="isLiveStreaming ? 'Processing' : livePreviewButtonTest"></sp-button>
                    </div>
                </div>
            </div>
        </div>

        <timeline v-if="journeyData" :journey="journeyData" :events="events" :events-to-show="[]" @active-journey="highlightJourney" @active-event-popup="showEvent" @active-event="highlightEvent"></timeline>

        <div class="speed-graph" v-if="isSpeedGraphShow">
            <speed-graph :journeys="speedingGraphData"></speed-graph>
        </div>

        <div class="table" v-if="isJourneyTableShow">
            <journeys-table :journeys="journeyTable.journeys" @redirect-journey="redirectToJourney" :current-journey="journeyUuid" is-journey></journeys-table>
        </div>
        <div class="details">
            <div class="map">
                <here-map>
                    <here-draw-journeys></here-draw-journeys>
                </here-map>
            </div>
            <div class="snapshot" v-if="isSnapshotsTableShow">
                <div class="buttons">
                    <div class="button-box">
                        <sp-button @click.native="showSharedEventsListDialog = !showSharedEventsListDialog" :disabled="!journeyData" sp-class="no-padding-right" small-icon icon="arrow-left" text="Shared events"></sp-button>
                    </div>
                    <div class="button-box">
                        <sp-button @click.native="showRequestFootageDialog = !showRequestFootageDialog" :disabled="!journeyData" sp-class="no-padding-right" small-icon icon="arrow-left" text="Request Footage"></sp-button>
                    </div>
                </div>
                <div class="header">
                    <div :class="['tab', activeTable === 'events'? 'active': '']" @click="activeTable = 'events'">Events</div>
                    <div :class="['tab', activeTable === 'snapshots'? 'active': '']" @click="activeTable = 'snapshots'">Snapshots</div>
                    <div :class="['tab', activeTable === 'videos'? 'active': '']" @click="activeTable = 'videos'">Videos</div>
                </div>
                <div class="tables">
                    <div class="events" v-if="activeTable === 'events'">
                        <v-data-table
                            :headers="eventsTable.headers"
                            :items="eventsTable.events"
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <tr :class="{ highlight: props.item.id === activeEvent }">
                                    <td :class="{'eventName': hasAllRoles(['DeviceEventView'])}" @click="showEvent({ eventId: props.item.id, hardwareId: props.item.hardwareId })">
                                        <div class="open-event">
                                            {{ eventName(props.item) }}
                                            <img :src="require('@/assets/icons/icon-search-red.svg')" width="16">
                                        </div>
                                    </td>
                                    <td>{{ dateFormat(props.item.triggerOn) }}</td>
                                    <td>{{ speedFormat(props.item.speed) }}</td>
                                    <td>{{ speedFormat(props.item.speedLimit) }} </td>
                                    <td v-if="hasAllRoles(['EventShareAdd'])" class="eventName" @click="shareEvent(props.item)">Share</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                    <div class="snapshots-table" v-if="activeTable === 'snapshots'">
                        <v-data-table
                            :headers="snapshotsTable.headers"
                            :items="snapshotsTable.snapshots"
                            hide-actions
                            :expand="true"
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td :class="{'eventName': hasAllRoles(['DeviceEventView'])}" @click="showEvent({ eventId: props.item.eventId, hardwareId: props.item.hardwareId })">
                                        <div class="open-event">
                                            {{ dateFormat(props.item.dateRequested.slice(0,19)+'Z') }}
                                            <img :src="require('@/assets/icons/icon-search-red.svg')" width="16">
                                        </div>
                                    </td>
                                    <td>{{ props.item.hardwareId }}</td>
                                    <td>{{ getMediaStatus(props.item.state) }}</td>
                                    <td v-if="hasAllRoles(['EventShareAdd'])" class="eventName" @click="shareEvent({ id: props.item.eventId, hardwareId: props.item.hardwareId})">Share</td>
                                </tr>
                            </template>
                            <template v-slot:expand="props">
                                <v-card flat>
                                    <v-carousel :cycle="false" v-if="props.item.mediaList !== null && props.item.mediaList.length > 0">
                                        <v-carousel-item v-for="item in props.item.mediaList" v-bind:key="item.id" :src="item.url">
                                        </v-carousel-item>
                                    </v-carousel>
                                    <div class="no-media" v-if="props.item.mediaList == null || props.item.mediaList.length === 0">
                                        No media available for this snapshot, try again later
                                    </div>
                                </v-card>
                            </template>
                        </v-data-table>
                    </div>
                    <div class="snapshots-table" v-if="activeTable === 'videos'">
                        <v-data-table
                            :headers="videosTable.headers"
                            :items="videosTable.videos"
                            hide-actions
                            :expand="true"
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td :class="{'eventName': hasAllRoles(['DeviceEventView'])}" @click="showEvent({ eventId: props.item.eventId, hardwareId: props.item.hardwareId })">
                                        <div class="open-event">
                                            {{ dateFormat(props.item.dateRequested.slice(0,19)+'Z') }}
                                            <img :src="require('@/assets/icons/icon-search-red.svg')" width="16">
                                        </div>
                                    </td>
                                    <td>{{ props.item.hardwareId }}</td>
                                    <td>{{ getMediaStatus(props.item.state) }}</td>
                                    <td v-if="hasAllRoles(['EventShareAdd'])" class="eventName" @click="shareEvent({ id: props.item.eventId, hardwareId: props.item.hardwareId})">Share</td>
                                </tr>
                            </template>
                            <template v-slot:expand="props">
                                    <v-carousel :cycle="false" v-if="props.item.mediaList !== null && props.item.mediaList.length > 0" :height="250">
                                        <v-carousel-item v-for="item in props.item.mediaList" v-bind:key="item.id">
                                            <div class="video-box">
                                                <video controls>
                                                    <source :src="item.url" :type="item.contentType">
                                                </video>
                                            </div>
                                        </v-carousel-item>
                                    </v-carousel>
                                    <div class="no-media" v-if="props.item.mediaList == null || props.item.mediaList.length === 0">
                                        No media available for this snapshot, try again later
                                    </div>
                            </template>
                        </v-data-table>
                    </div>
                </div>
            </div>

            <v-dialog
                v-model="dialogRequestVideo"
                max-width="500"
                content-class="spillard-dialog dialogRequestVideo"
            >

                <v-card>
                    <div class="close" @click="dialogRequestVideo = !dialogRequestVideo">
                        <i class="material-icons">close</i>
                    </div>
                    <div class="info-block">
                        Request video
                    </div>
                    <v-card-text>
                        <div class="label">Video length</div>

                        <div class="filter">
                            <v-select
                                :items="videoLengths"
                                label="Video length seconds"
                                v-model="dialogRequestVideoData.videoLength"
                                item-text="text"
                                item-value="key"
                                required
                                outline
                                single-line
                            ></v-select>
                        </div>

                        <div class="button">
                            <sp-button @click.native="requestSnapshotVideo" sp-class="no-padding-right" small-icon icon="arrow-left" text="Request video"></sp-button>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>

        <videos v-if="isStreamingHardware" v-model="isLivePreviewModal" :is-hardware-online="isHardwareOnline" :vehicle-uuid="vehicleUuid" :available-channels-flag="availableChannelsFlag" :hardware-id="hardwareId" @isStreaming="onLiveStreaming"></videos>

        <remote-playback v-if="isStreamingHardware && activeDevice != null" v-model="isRemotePlaybackModal" :vehicle-uuid="vehicleUuid" :is-hardware-online="isHardwareOnline" :active-device="activeDevice" @calendar-processed="calendarProcessed"></remote-playback>

        <request-footage-dialog
            v-if="journeyData && hasAllRoles(['DeviceView'])"
            v-model="showRequestFootageDialog"
            :journey="journeyData"
            :date="date"
        ></request-footage-dialog>
        <share-event
            v-if="hasAllRoles(['EventShareAdd'])"
            v-model="showShareEventDialog"
            :event="eventToShare"
        ></share-event>

        <share-event-list
            v-if="journeyData && hasAllRoles(['EventShareView'])"
            v-model="showSharedEventsListDialog"
            :hardware-id="journeyData ? journeyData.hardwareId : null"
        ></share-event-list>

    </div>
</template>

<script>
import moment from 'moment'
import SpButton from '@/components/forms/Button'
import EnumsManager from '@/menagers/EnumsManager'
import Timeline from '@/views/Journeys/Timeline/Timeline'
import SpeedGraph from '@/views/Journeys/SpeedGraph'
import JourneysTable from '@/views/Journeys/JourneysTable'
import { mapActions, mapGetters, mapState } from 'vuex'
import { formatDate, searchEnumById, calculateSpeedOrDistanceUnit } from '@/helpers/Utils'
import Videos from '@/views/Journeys/Videos'
import RemotePlayback from '@/views/Journeys/RemotePlayback'
import HereMap from '@/components/maps/here/HereMap'
import HereDrawJourneys from '@/components/maps/here/components/HereDrawJourneys'
import { DeviceEventApi, JourneyApi, VehicleApi, TelemetryApi, MediaRequestApi, DeviceApi, StreamingApi, StatisticsApi } from '@/api'
import { CollectionTransformer, EventTransformer } from '@/transformers'
import ShareEvent from '@/views/Journeys/ShareEvent'
import ShareEventList from '@/views/Journeys/ShareEventList'
import RequestFootageDialog from '@/views/Journeys/RequestFootageDialog'
import Icon from '@/components/atoms/Icon'

const vehicleApi = new VehicleApi()
const telemetryApi = new TelemetryApi()
const journeyApi = new JourneyApi()
const deviceEventApi = new DeviceEventApi()
const mediaRequestApi = new MediaRequestApi()
const deviceApi = new DeviceApi()
const streamingApi = new StreamingApi()
const statisticsApi = new StatisticsApi()

const collectionTransformer = new CollectionTransformer()
const eventTransformer = new EventTransformer()

export default {
    name: 'Journeys',
    async created () {
        this.vehicleUuid = this.$route.params.vehicleUuid
        this.journeyUuid = this.$route.params.journeyUuid || null
        this.requestDate = this.$route.params.date || null

        this.date = moment()
        if (null !== this.requestDate) {
            this.date = moment(this.requestDate)
        }
        this.maxJourneyDatePickerDate = moment().format('YYYY-MM-DD')
        this.dateString = this.date.format('YYYY-MM-DD')
    },
    async mounted () {
        this.$store.state.isOverlayActive = true

        await this.init()

        this.$store.state.isOverlayActive = false
    },
    components: {
        ShareEventList,
        RequestFootageDialog,
        ShareEvent,
        RemotePlayback,
        Videos,
        Icon,
        JourneysTable,
        SpeedGraph,
        Timeline,
        SpButton,
        HereMap,
        HereDrawJourneys
    },
    data () {
        return {
            availableDays: [],
            activeDevice: null,
            showSharedEventsListDialog: false,
            showCreateSnapshotDialog: false,
            showShareEventDialog: false,
            showRequestFootageDialog: false,
            eventToShare: {},
            showShareSnapshotDialog: false,
            isRemotePlaybackAvailable: true,
            isLiveStreaming: false,
            isLiveViewAvailable: false,
            showLiveViewDialog: false,
            isRemotePlaybackModal: false,
            vehicleUuid: null,
            journeyUuid: null,
            requestDate: null,
            vehicle: null,
            map: null,
            group: null,
            ui: null,
            mapObjects: {
                circles: [],
                markers: [],
                eventCircles: [],
                eventMarkers: []
            },
            mapName: 'journeyMap',
            activeTable: 'events',
            activeJourney: null,
            timelineStart: null,
            timelineEnd: null,
            date: null,
            dateString: null,
            maxJourneyDatePickerDate: '',
            isSnapshotsTableShow: false,
            isJourneyTableShow: false,
            isDatePickerShow: false,
            isSpeedGraphShow: false,
            isLivePreviewModal: false,
            startDate: null,
            endDate: null,
            pieces: 0,
            events: [],
            activeEventTypes: [],
            timeouts: [],
            activeEvent: null,
            googleRequests: 0,
            journeyStatus: '',
            journeys: [],
            journeyData: null,
            todaysJourney: null,
            eventsTable: {
                headers: [
                    {
                        text: 'Event',
                        align: 'left',
                        sortable: false,
                        name: 'eventName'
                    },
                    {
                        text: 'Time',
                        align: 'center',
                        sortable: false,
                        name: 'dateRaised'
                    },
                    {
                        text: 'Speed',
                        align: 'left',
                        sortable: false,
                        name: 'speed'
                    },
                    {
                        text: 'Limit',
                        align: 'left',
                        sortable: false
                    },
                    {
                        text: 'Share',
                        align: 'center',
                        sortable: false,
                        class: !this.hasAllRoles(['EventShareAdd']) ? 'd-none' : ''
                    }
                ]
            },
            snapshotsTable: {
                headers: [
                    {
                        text: 'Requested Date',
                        align: 'left',
                        sortable: false,
                        name: 'dateRequested'
                    },
                    {
                        text: 'Device ID',
                        align: 'left',
                        sortable: false,
                        name: 'hardwareId'
                    },
                    {
                        text: 'Status',
                        align: 'left',
                        sortable: false
                    },
                    {
                        text: 'Share',
                        align: 'center',
                        sortable: false,
                        class: !this.hasAllRoles(['EventShareAdd']) ? 'd-none' : ''
                    }
                ],
                snapshots: []
            },
            videosTable: {
                headers: [
                    {
                        text: 'Requested Date',
                        align: 'left',
                        sortable: false,
                        name: 'dateRequested'
                    },
                    {
                        text: 'Device ID',
                        align: 'left',
                        sortable: false,
                        name: 'hardwareId'
                    },
                    {
                        text: 'Status',
                        align: 'left',
                        sortable: false
                    },
                    {
                        text: 'Share',
                        align: 'center',
                        sortable: false,
                        class: !this.hasAllRoles(['EventShareAdd']) ? 'd-none' : ''
                    }
                ],
                videos: []
            },
            journeyTable: {
                journeys: []
            },
            livePreviewStatus: null,
            livePreviewButtonTest: 'Live view',
            remotePlaybackPreviewStatus: null,
            remotePlaybackPreviewButtonText: 'Remote playback',
            remotePlaybackTimeout: null,
            platform: null,
            dialogRequestVideo: false,
            dialogRequestVideoData: {
                videoLength: '10',
                videoLengthMask: '###',
                created: null
            },
            videoLengths: [
                {
                    key: '10',
                    text: '10 seconds'
                },
                {
                    key: '15',
                    text: '15 seconds'
                },
                {
                    key: '20',
                    text: '20 seconds'
                },
                {
                    key: '30',
                    text: '30 seconds'
                },
                {
                    key: '45',
                    text: '45 seconds'
                },
                {
                    key: '60',
                    text: '60 seconds'
                }
            ],
            availableChannelsFlag: 0,
            timeline: null,
            speedingGraphData: null,
            hardwareId: null,
            deviceStatistics: null
        }
    },
    computed: {
        ...mapState([
            'vehicleStatuesType'
        ]),
        ...mapGetters({
            getVehicleJourney: 'trackingModule/getVehicleJourney',
            getDeviceCommandStates: 'dictionaryModule/getDeviceCommandStates',
            eventTypes: 'dictionaryModule/getEventTypes',
            getChannels: 'dictionaryModule/getChannels',
            getSpeedUnit: 'authModule/getSpeedUnit'
        }),
        isStreamingHardware () {
            return null != this.hardwareId && '0' === this.hardwareId.charAt(0)
        },
        isHardwareOnline () {
            return null != this.hardwareId && null != this.deviceStatistics && this.deviceStatistics.devicesOnline.includes(this.hardwareId)
        }
    },
    methods: {
        ...mapActions({
            setActiveJourney: 'trackingModule/setActiveJourney',
            setJourneysData: 'trackingModule/setJourneysData'
        }),
        async init () {
            try {
                await this.getVehicle()
                await this.getJourneys()
                await this.getJourneyData()
                this.$store.state.isOverlayActive = false
            } catch (e) {
                this.$store.state.isOverlayActive = false
            }
        },
        clearData () {
            this.eventsCounter = {
                1: 0,
                2: 0,
                3: 0,
                4: 0,
                5: 0,
                6: 0,
                7: 0,
                8: 0,
                9: 0,
                10: 0
            }

            this.activeJourney = null
            this.timelineStart = moment()
            this.timelineEnd = moment()
            this.startDate = moment()
            this.endDate = moment()
            this.journeys = []
            this.events = []
            this.availableChannelsFlag = 0

            this.group.removeAll()
        },
        async getCalendar () {
            const response = await streamingApi.requestCalendar(
                this.activeDevice ? this.activeDevice.hardwareId : this.hardwareId,
                2
            )

            if (!response.isSuccess || !response.payload) {
                return
            }

            response.payload.availableDays.forEach(date => {
                this.availableDays.push(moment(date).format('YYYY-MM-DD'))
            })
        },
        eventAvailable (eventId) {
            let position = this.activeEventTypes.indexOf(eventId)

            if (0 > position) {
                this.activeEventTypes.push(eventId)
            } else {
                this.activeEventTypes.splice(position, 1)
            }

            if (0 === this.activeEventTypes.length) {
                this.eventsTable.events.forEach((event) => {
                    event.isVisible = true
                })
            } else {
                this.eventsTable.events.forEach((event) => {
                    event.isVisible = event.eventTypes.some(r => this.activeEventTypes.includes(r))
                })
            }
        },
        async getVehicle () {
            const response = await vehicleApi.getVehicle(this.vehicleUuid)
            this.vehicle = response.payload
        },
        async getJourneyData () {
            this.$store.state.isOverlayActive = true
            let response
            let hardwareId
            const deviceResponse = await deviceApi.getDevices({
                vehicleId: this.vehicleUuid
            })

            if (deviceResponse.isSuccess && 0 < deviceResponse.payload.items.length) {
                hardwareId = deviceResponse.payload.items[0].hardwareId
                this.hardwareId = hardwareId
            }

            const responseStatistics = await statisticsApi.getDeviceStatistics()
            if (responseStatistics.isSuccess) {
                this.deviceStatistics = responseStatistics.payload
            }

            if (this.deviceStatistics.devicesOnline.includes(this.hardwareId)) {
                this.journeyStatus = 'online'
            } else if (this.deviceStatistics.devicesOffline.includes(this.hardwareId)) {
                this.journeyStatus = 'offline'
            }

            if (this.hardwareId) {
                const deviceResponse = await deviceApi.getDevice(hardwareId)

                if (deviceResponse.isSuccess) {
                    this.activeDevice = deviceResponse.payload
                }

                if (this.deviceStatistics.devicesOnline.includes(hardwareId)) {
                    this.journeyStatus = 'online'
                } else if (this.deviceStatistics.devicesOffline.includes(hardwareId)) {
                    this.journeyStatus = 'offline'
                }
            }

            if ('current' === this.journeyUuid && hardwareId) {
                const thisJourney = this.journeyTable.journeys.filter(journey => 'current' === journey.id)
                const startTime = thisJourney[0].startPoint.utc
                const startPointTime = moment.utc(startTime).format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
                response = await telemetryApi.getSnappedTelemetry(hardwareId, startPointTime)
                if (!response.isSuccess) this.isJourneyTableShow = true
            } else if (this.journeyUuid) {
                response = await journeyApi.getJourney(this.journeyUuid)
            } else if (0 < this.journeyTable.journeys.length) {
                await this.redirectToJourney(this.journeyTable.journeys[0])
                return
            }

            let journey = response.payload.journey ? response.payload.journey : response.payload
            if (!journey || journey.error) {
                return
            }

            const dateFrom = moment.utc(this.getPointTimestamp(journey.startPoint)).format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
            const dateTo = moment.utc(this.getPointTimestamp(journey.endPoint)).format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'

            const timelineResponse = await journeyApi.getJourneyTimeline(dateFrom, dateTo, this.vehicle.id)
            journey.timelineBlocks = timelineResponse.payload.timelineBlocks.filter((block) => {
                return moment(block.startTime).isSameOrAfter(this.getPointTimestamp(journey.startPoint)) && moment(block.endTime).isSameOrBefore(this.getPointTimestamp(journey.endPoint))
            })

            const filteredEvents = this.eventTypes.filter(event => 0 !== event.categoryId).map(event => event.id)
            const eventsResponse = await deviceEventApi.getDeviceEvents({
                dateFrom: this.getPointTimestamp(journey.startPoint),
                dateTo: this.getPointTimestamp(journey.endPoint),
                vehicleId: this.vehicle.id,
                eventTypes: filteredEvents
            })

            journey.events = collectionTransformer.transform(eventTransformer, eventsResponse.payload.items.filter((item) => {
                return 0 < item.locations.length && null != item.locations[0]
            }))

            this.journeyData = journey
            this.setActiveJourney(this.journeyData)
            this.setJourneysData({
                journey: this.journeyData,
                vehicle: this.vehicle
            })

            let countedEvents = 0
            this.eventsTable.events = journey.events

            this.events = this.eventTypes.filter((event) => {
                return 1 === event.categoryId || 0 === event.categoryId
            }).map((event) => {
                let counter = 0
                this.eventsTable.events.forEach((item) => {
                    if (item.eventTypes.includes(event.id)) {
                        countedEvents++
                        counter++
                    }
                })

                event.counter = counter

                return event
            })

            const unknownEvent = this.events.find((item) => {
                return 0 === item.id
            })

            unknownEvent.counter = this.eventsTable.events.length - countedEvents

            const speedingTelemetryResponse = await telemetryApi.getSpeedingData(this.journeyData ? this.journeyData.hardwareId : hardwareId, dateFrom, dateTo)

            if (speedingTelemetryResponse.isSuccess) {
                this.speedingGraphData = speedingTelemetryResponse.payload
            }

            const mediaResponse = await mediaRequestApi.getMediaRequests({
                videoTimeFrom: dateFrom,
                videoTimeTo: dateTo,
                hardwareId: this.journeyData ? this.journeyData.hardwareId : hardwareId
            })

            mediaResponse.payload.items.forEach(media => {
                if (7 === media.type) {
                    this.videosTable.videos.push(media)
                } else {
                    this.snapshotsTable.snapshots.push(media)
                }
            })
        },
        async getJourneys (openTable = false) {
            const dateFrom = moment(this.dateString).startOf('d').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
            const dateTo = moment(this.dateString).endOf('d').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'

            const response = await journeyApi.getJourneys(dateFrom, dateTo, this.vehicle.id)
            if (!response.isSuccess) {
                return
            }

            if (response.payload.processedJourneys && 0 < response.payload.processedJourneys.length) {
                this.journeyTable.journeys = response.payload.processedJourneys
            } else {
                this.journeyTable.journeys = response.payload.unprocessedJourneys
            }

            if (response.payload.currentJourney) {
                this.todaysJourney = response.payload.currentJourney
                this.journeyTable.journeys.unshift(this.todaysJourney)
            } else if (this.journeyTable.joruneys && 0 < this.journeyTable.length) {
                this.todaysJourney = this.journeyTable.journeys[0]
            }
        },
        async getSnapshot (props) {
        },
        highlightJourney (journey) {
        },
        highlightEvent (event) {
        },
        requestSnapshotVideo () {
        },
        showEvent (payload) {
            if (this.hasAllRoles(['DeviceEventView'])) {
                this.$store.commit('setEventId', payload)
            }
        },
        async dateChanged () {
            this.date = moment(this.dateString)
            await this.getJourneys()
            await this.redirectToJourney(this.journeyTable.journeys[0])
        },
        dateFormat (date) {
            return formatDate(date)
        },
        speedFormat (speed) {
            return 0 === this.getSpeedUnit ? speed + ' kph' : calculateSpeedOrDistanceUnit(speed, 'mi') + ' mph'
        },
        async redirectToJourney (journey) {
            if (journey.id === this.journeyUuid) {
                return
            }
            this.$store.state.isOverlayActive = true

            this.$forceUpdate()
            this.$router.push(`/journeys/${this.vehicleUuid}/${journey.id}/${this.dateString}`)
            this.journeyUuid = journey.id
            this.requestDate = this.dateString
            this.clearData()
            await this.init()
        },
        async requestLiveViewAvailability () {
            if (!this.activeDevice) return

            this.livePreviewStatus = 'processing'

            const channelsFlag = (this.activeDevice.channelFlag >>> 0).toString(2).split('').reverse()

            const channels = this.getChannels.filter((channel) => {
                return 0 !== channel.id
            }).filter((channel, index) => {
                if (0 === channelsFlag[index] || null == channelsFlag[index]) {
                    return
                }

                return channel.id === Math.pow(2, index)
            })
            const response = await streamingApi.requestFiles(
                this.activeDevice ? this.activeDevice.hardwareId : this.hardwareId,
                1,
                0,
                moment().format('YYYY-MM-DD')
            )
            if (!response.isSuccess || !response.payload || 0 === response.payload.files.length) {
                this.livePreviewStatus = null
                return
            }

            const availableVideos = response.payload.files
            const recentAvailableVideos = availableVideos.filter(video => moment().subtract(10, 'minutes').isBefore(moment(video.endTime)))

            if (0 === recentAvailableVideos.length) {
                return
            }

            const availableChannels = [...new Set(recentAvailableVideos.map(video => video.channel))]

            const availableChannelsList = channels.filter(channel => availableChannels.includes(channel.id))

            this.availableChannelsFlag = availableChannelsList.reduce((a, b) => a + b.id, 0)

            this.livePreviewStatus = null
            this.isLiveViewAvailable = true
        },
        addNewSnapshot (snapshot) {
            this.snapshotsTable.snapshots.push(snapshot)
        },
        calendarProcessed () {
            this.remotePlaybackPreviewStatus = null
            this.remotePlaybackPreviewButtonText = 'Remote playback'

            if (null !== this.remotePlaybackTimeout) {
                clearTimeout(this.remotePlaybackTimeout)
            }
        },
        eventName (event) {
            const eventType = this.eventTypes.find((elem) => {
                return elem.id === event.eventTypes[0]
            })

            return eventType.key || 'Unknown'
        },
        getClassName (statusId) {
            let className
            let vehicleStatusEnum = EnumsManager.searchById(this.vehicleStatuesType, statusId)
            let vehicleStatusName = null !== vehicleStatusEnum ? vehicleStatusEnum.name : ''
            switch (vehicleStatusName) {
                case 'Driving':
                    className = 'online'
                    break
                case 'Offline':
                    className = 'offline'
                    break
                default:
                    className = 'sleep'
                    break
            }

            return className
        },
        getColor (statusId) {
            let className
            let vehicleStatusEnum = EnumsManager.searchById(this.vehicleStatuesType, statusId)
            let vehicleStatusName = null !== vehicleStatusEnum ? vehicleStatusEnum.name : ''
            switch (vehicleStatusName) {
                case 'Driving':
                    className = '#AED51B'
                    break
                case 'Offline':
                    className = '#FF2B55'
                    break
                default:
                    className = '#4879B2'
                    break
            }

            return className
        },
        getPointTimestamp (point) {
            return point.utcTimestamp ? point.utcTimestamp : point.utc
        },
        shareEvent (event) {
            this.eventToShare = event
            this.showShareEventDialog = !this.showShareEventDialog
        },
        getMediaStatus (status) {
            return searchEnumById(this.getDeviceCommandStates, status)
        },
        onLiveStreaming (status) {
            this.isLiveStreaming = status
        }
    }
}
</script>

<style lang="scss">
#journey {
    padding-top: 30px;

    .v-text-field__details {
        display: none !important;
    }

    .v-input__prepend-outer {
        position: absolute;
        top: -3px;
        right: 12px;
    }

    .journey-top {
        display: flex;

        .vehicle {
            display: flex;
            height: 50px;
            background: #F5F5F5;
            padding: 0;
            font-size: 14px;
            font-weight: 400;

            div {
                display: flex;
                align-items: center;
                margin-right: 20px;
            }

            span {
                font-weight: bold;
                padding-left: 5px;
            }

            .icon-slot {
                width: 50px;
                height: 50px;
                color: $font;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: $secondary;
                background-repeat: no-repeat;
                background-position: center;
            }
        }
    }

    .events {
        margin-left: auto;

        ul {
            display: flex;
            list-style: none;
            margin: 0;
            padding: 0;

            li {
                height: 50px;
                background: #F5F5F5;
                margin: 0 5px;
                display: flex;
                align-items: center;
                padding: 0 13px;
                font-weight: 500;
                cursor: pointer;

                &:first-child {
                    margin-left: 0;
                }

                &.icon::before {
                    content: '';
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                    margin-right: 5px;
                    height: 22px;
                    position: relative;
                }

                &.active {
                    background: $primary-default;
                    color: $white;
                        &.icon::before {
                            filter: brightness(10)
                    }
                }

                &.disabled {
                    cursor: not-allowed;
                    opacity: 0.2;
                }

                &.shock::before {
                    background-image: url('~@/assets/icons/icon-event.svg');
                    width: 21px;
                }

                &.accelerate::before {
                    background-image: url('~@/assets/icons/icon-acceleration.svg');
                    width: 36px;
                }

                &.brake::before {
                    background-image: url('~@/assets/icons/icon-breaking.svg');
                    width: 36px;
                }

                &.user::before {
                    background-image: url('~@/assets/icons/icon-user-black.svg');
                    width: 20px;
                }

                &.turn::before {
                    background-image: url('~@/assets/icons/icon-turning.svg');
                    width: 20px;
                }

                &.alarm-first::before {
                    background-image: url('~@/assets/icons/icon-alarm-first.svg');
                    width: 20px;
                }

                &.alarm-second::before {
                    background-image: url('~@/assets/icons/icon-alarm-second.svg');
                    width: 20px;
                }

                &.alarm::before {
                    background-image: url('~@/assets/icons/icon-alarm.svg');
                    width: 20px;
                    top: -1px;
                }

                &.speed::before {
                    background-image: url('~@/assets/icons/icon-speed-event.svg');
                    width: 20px;
                    top: -2px;
                }

                &.unknown::before {
                    background-image: url('~@/assets/icons/icon-unknown.svg');
                    width: 20px;
                    top: -2px;
                }
            }
        }
    }

    .overview {
        display: flex;
        margin-top: 30px;

        .left-side {
            margin-right: auto;
            display: flex;

            .journey-status {
                font-weight: 500;
                display: flex;
                align-items: center;

                &::after {
                    content: '';
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    margin-left: 10px;
                    background: $info;
                }

                &.online::after {
                    background: $success;
                }

                &.offline::after {
                    background: $danger;
                }
            }

            .journey-id {
                font-weight: 500;
                display: flex;
                align-items: center;
                margin: 0 15px;
            }

            .journey-list {
                margin-left: 10px;
                .v-input__slot {
                    margin-bottom: 0 !important;
                }
            }
        }

        .right-side {
            margin-left: auto;

            .buttons {
                display: flex;

                .button-box {
                    margin-left: 10px;
                }
            }
        }
    }

    .table {
        margin-top: 30px;
    }

    .details {
        margin-top: 30px;
        display: flex;

        .map {
            width: 100%;
            height: 575px;
            position: relative;
            z-index: 0;
        }

        .snapshot {
            min-width: 500px;
            height: 575px;

            .buttons {
                display: flex;
                justify-content: space-between;
                margin-bottom: 9px;
            }

            .header {
                display: flex;

                .tab {
                    display: flex;
                    flex-grow: 1;
                    background: $secondary;
                    color: $font;
                    width: 100%;
                    height: 50px;
                    font-weight: 500;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    &:hover,
                    &.active {
                        background: $primary;
                        color: $secondary;
                    }
                }
            }

            .tables {
                max-height: calc(575px - 50px);
                overflow: auto;

                .events, .snapshots-table {
                    .eventName {
                        cursor: pointer;
                        color: $primary;

                        &:hover {
                            color: $secondary;
                        }
                    }

                    .highlight {
                        .eventName {
                            cursor: pointer;
                            color: $white;

                            &:hover {
                                color: $secondary;
                            }
                        }
                    }
                }

                .snapshots-table {
                    .snapshot-row {
                        cursor: pointer;

                        &:hover {
                            background: $primary;

                            td {
                                color: $white;
                            }
                        }
                    }

                    .v-carousel {
                        height: 250px !important;

                        .v-carousel__controls {
                            height: 30px;
                            .v-btn {
                                height: 18px;
                            }

                            i {
                                font-size: 14px !important;
                            }
                        }
                    }

                    .no-media {
                        height: 250px;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        border: 1px solid $gray;
                    }

                    .video-box {
                        width: 400px !important;
                        height: 250px !important;

                        video {
                            width: 400px !important;
                            height: 250px !important;
                            margin: 0 auto;
                        }
                    }
                }

                .highlight {
                    background: $primary;

                    td {
                        color: $white;
                        font-weight: bold;
                    }
                }
            }
        }
    }
}

.spillard-dialog {
    .info-block {
        margin-bottom: 10px;
    }

    .button {
        text-align: center;
    }

    .label {
        font-size: 14px;
        padding-bottom: 10px;
    }
}

.open-event {
    display: flex;

    img {
        margin-left: 5px;
    }
}
</style>
